// extracted by mini-css-extract-plugin
module.exports = {"content":"ChatEndedEvent_content__32vhv","fullWidth":"ChatEndedEvent_fullWidth__coBTW","compact":"ChatEndedEvent_compact__DkBk7"};